module.exports = global["SampleGraph"] = require("-!/var/www/ridewithgps.com/releases/20261103180724/node_modules/babel-loader/lib/index.js?{\"presets\":[\"es2015\"]}!/var/www/ridewithgps.com/releases/20261103180724/node_modules/eslint-loader/index.js!./sample_graph.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?SampleGraph!./public/javascripts/sample_graph/sample_graph.js-exposed
// module id = 25
// module chunks = 2